import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link } from "react-router-dom";
import { Card, Col, Nav, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Grid } from "gridjs-react";

export default function PublisherInventory() {

  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">

        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link href="#">PUB Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Inventory</li>
            </ol>
            <h4 className="main-title mb-0">Inventory</h4>
          </div>

          <Nav as="nav" className="nav-icon nav-icon-lg">
            <OverlayTrigger overlay={<Tooltip>Print</Tooltip>}>
              <Nav.Link href=""><i className="ri-printer-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Report</Tooltip>}>
              <Nav.Link href=""><i className="ri-bar-chart-2-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>New Inventory</Tooltip>}>
              <Nav.Link href="/publisher/inventory/type"><i className="ri-add-line"></i></Nav.Link>
            </OverlayTrigger>
          </Nav>

        </div>

        <Row className="g-3 justify-content-center">
  
          <Col md="12">
            <Card className="card-one">
              <Card.Body>
                <div className="table-responsive">
                  <Grid
                    data={[
                      ['1', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['2', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['3', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['4', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['5', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['6', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['7', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['8', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['9', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['10', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['11', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['12', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['13', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['14', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['15', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['16', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['17', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['18', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['19', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['20', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['21', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['22', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['23', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['24', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['25', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['26', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['27', 'Top 5 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['28', 'Top 10 Trade Finance Providers', 'Top List', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['29', 'Top 10 Trade Finance Providers', 'Multi-Item Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00'],
                      ['30', 'Top 10 Trade Finance Providers', 'Single Banner', 'Trade Finance, US', 'TFG', '1,200', '$20.00', '$32.00']
                    ]}
                    columns={['ID', 'Name', 'Block Type', 'Categories', 'Site', '30 Day Views', 'Min Bid', 'Top Bid']}
                    search={true}
                    pagination={{
                      enabled: true,
                      limit: 15
                    }}
                    sort={true}
                    className={{
                      table: 'table table-bordered table-hover mb-0'
                    }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <Footer />
      </div>
    </React.Fragment>
  )
}